export default __webpack_public_path__ + "images/0x1f9840a85d5af5bf1d1762f925bdaddc4201f984.png";